import { render, staticRenderFns } from "./FormDeleted.vue?vue&type=template&id=31ae0a72&scoped=true"
import script from "./FormDeleted.vue?vue&type=script&lang=js"
export * from "./FormDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ae0a72",
  null
  
)

export default component.exports